<template>
    <el-select :multiple="multiple" v-model="val" @change="handleChange" placeholder="请选择文件分类">
        <el-option v-for="item in options" :key="item.uuid" :label="item.name" :value="item.uuid"> </el-option>
    </el-select>
</template>

<script>
import { list } from "@/api/file/category";
export default {
    props: {
        value: {
            type: String | Array,
            default: "",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            val: "",
            options: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val;
            },
            immediate: true,
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        search() {
            list({
                page_index: 1,
                page_size: 9999,
            }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.options = result.data;
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleChange(val) {
            this.$emit("input", val);
            this.$emit("change", val);
        },
    },
};
</script>

<style></style>
